import { http } from 'services';

// Personal - List Measurements, params: date_from
export function getListMeasurements(params, cbSuccess, cbError) {
  http.get(
    'personal/measurements',
    params,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Get Measurement by ID, measurementID can be also -1, will return empty form
export function getMeasurementByID(measurementID, cbSuccess, cbError) {
  http.get(
    `personal/measurements/${measurementID}`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Add Measurement
export function addMeasurement(payload, cbSuccess, cbError) {
  http.post(
    'personal/measurements',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Update Measurement
export function updateMeasurement(measurementID, payload, cbSuccess, cbError) {
  http.patch(
    `personal/measurements/${measurementID}`,
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Remove Measurement
export function removeMeasurement(measurementID, cbSuccess, cbError) {
  http.delete(
    `personal/measurements/${measurementID}`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-measurements.js